module.exports = __webpack_public_path__ + "media/man1.e9055eaa.wav";